/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { TouchableOpacity, View } from "react-native";
import Icon from "react-icons-kit";
import { closeRound } from "react-icons-kit/ionicons/closeRound";
import Rodal from "rodal";

import { Scalars } from "graphql/internal/generated";
import { ReportIssueView, Text } from "UpduoLibrary";
import { skaleBlack } from "config/UpduoColors";

interface IssueModalProps {
  sessionId?: null | Scalars["GlobalID"];
  isVisible: boolean;
  onDismiss: () => void;
}

export default function IssueModal({
  sessionId,
  isVisible,
  onDismiss,
}: IssueModalProps) {
  return (
    <Rodal
      visible={isVisible}
      onClose={() => {
        onDismiss();
      }}
      customStyles={{
        borderRadius: 10,
        minWidth: 600,
        minHeight: 470,
        padding: 20,
        overflow: "visible",
      }}
    >
      <View style={{ borderRadius: 18, minWidth: 560, overflow: "visible" }}>
        <Text
          isHeading={true}
          style={{
            fontSize: 16,
            color: skaleBlack,
            textAlign: "center",
            alignSelf: "center",
            marginBottom: 20,
          }}
        >
          {"Report an Issue"}
        </Text>
        <ReportIssueView sessionId={sessionId} onFinish={onDismiss} />
        <View
          style={{
            position: "absolute",
            top: 0,
            right: 0,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              onDismiss();
            }}
          >
            <Text
              style={{
                color: skaleBlack,
              }}
            >
              <Icon size={20} icon={closeRound} />
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </Rodal>
  );
}
